import { NavDropdown, Navbar, Nav } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { UilBars } from "@iconscout/react-unicons";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../../auth/store/authSlice";
import LogoutModal from "../LogoutModal";

const DropDownNavigation = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [logOut, setLogOut] = useState(false);


  const handleNavigate = (navigation) => {
   
    navigate(`/${navigation}`)

  }

  const handleLogoutModal = () => {
    setLogOut(!logOut);

  };
  const queryParams = new URLSearchParams(window.location.search);
  const handleLogout = () => {
    dispatch(logout())
    navigate(`/login?${queryParams.toString()}`);
  }
  return (

    <>
      <Nav
        className="me-auto my-2 my-lg-0"
        style={{ maxHeight: '100px' }}
        navbarScroll
      >
        <NavDropdown title={<UilBars

          style={{ cursor: "pointer" }}
          size="18"
        />} id="navbarScrollingDropdown">

          <NavDropdown.Item onClick={() => { handleNavigate('business') }}>
            My Businesses
          </NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item onClick={() => { handleNavigate('myaccount') }}>
            My Account
          </NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item className="text-danger" onClick={handleLogoutModal}>
            Logout
          </NavDropdown.Item>


        </NavDropdown>
      </Nav>
      {logOut && <LogoutModal onConfirm={handleLogout} onCancel={setLogOut} />}
    </>
  )

}
export default DropDownNavigation